import { Facebook, Instagram, Mail, MessageCircle } from "lucide-react";

export default function Footer({ email, whatsapp }) {
  return (
    <footer
      data-testid="site-footer"
      className="bg-primary text-primary-foreground"
    >
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <div className="grid h-10 w-10 place-items-center rounded-full bg-[hsl(41_85%_55%)] font-serif text-primary">
                A
              </div>
              <div>
                <div className="font-serif text-xl">AfroLingo</div>
                <div className="text-[10px] uppercase tracking-[0.25em] opacity-80">
                  African Language Academy
                </div>
              </div>
            </div>
            <p className="mt-6 max-w-md text-primary-foreground/80">
              Live online Hausa classes for children and adults across the UK.
              Taught by qualified native teachers from Nigeria.
            </p>
          </div>

          <div>
            <h5 className="mb-4 text-sm uppercase tracking-widest opacity-80">
              Contact
            </h5>
            <ul className="space-y-3 text-primary-foreground/90">
              <li>
                <a
                  href={`mailto:${email}`}
                  className="inline-flex items-center gap-2 hover:opacity-80"
                  data-testid="footer-email"
                >
                  <Mail className="h-4 w-4" /> {email}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${whatsapp.replace(/[^0-9]/g, "")}`}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 hover:opacity-80"
                  data-testid="footer-whatsapp"
                >
                  <MessageCircle className="h-4 w-4" /> WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 hover:opacity-80"
                >
                  <Facebook className="h-4 w-4" /> Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 hover:opacity-80"
                >
                  <Instagram className="h-4 w-4" /> Instagram
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="mb-4 text-sm uppercase tracking-widest opacity-80">
              Legal
            </h5>
            <ul className="space-y-3 text-primary-foreground/90">
              <li>
                <a href="#" className="hover:opacity-80">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="hover:opacity-80">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="/admin/login" className="hover:opacity-80" data-testid="footer-admin-link">
                  Admin
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-primary-foreground/20 pt-6 text-sm text-primary-foreground/70 md:flex-row">
          <div>© {new Date().getFullYear()} AfroLingo · African Language Academy. All rights reserved.</div>
          <div>Made with love for the diaspora.</div>
        </div>
      </div>
    </footer>
  );
}
